 <form name="tableItemEditForm" #tableItemEditForm="ngForm">
    <div class="row">
      <div class="col-sm-12">
        <div class="form-group mb-2">
          <label for="Benefit"><span class="mandatory">*</span>{{'CardFamilyBenefits.FamilyBenefitsTable.BenefitType' | translate}}</label>
        </div>
      </div>

      <div class="col-sm-12 mb-4">
        <div class="row" [class.ng-invalid]="item.benefitTypes.benefitTypesList.length == 0">
          <div class="col-sm-6" *ngFor="let domain of benefitTypes; let i = index">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="benefitTypeCB_{{i}}" [checked]="item.benefitTypes.benefitTypesList.indexOf(domain.code) != -1"
                     (change)="checkBoxChanged($event,domain.code,item.benefitTypes.benefitTypesList);cleanSubTypes($event,domain.code)">
              <label class="custom-control-label" for="benefitTypeCB_{{i}}">{{domain.description}}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-12 mb-3" *ngFor="let domain of subBenefitTypes; let i = index">
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="subBenefitTypeCB_{{i}}" [checked]="item.subBenefitTypes.subBenefitTypesList.indexOf(domain.code) != -1"
                       (change)="checkBoxChanged($event,domain.code,item.subBenefitTypes.subBenefitTypesList)" [disabled]="item.benefitTypes.benefitTypesList.indexOf(domain.value) == -1">
                <label class="custom-control-label" for="subBenefitTypeCB_{{i}}">{{domain.description}}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-12 mb-3">
        <input hidden type="number" [(ngModel)]="item.benefitTypes.benefitTypesList.length" name="benefitTypesLength" #benefitTypesLength="ngModel" minValue="1" required/>
        <validation-message [control]="benefitTypesLength" [message]="'ValidationMessages.required' | translate"></validation-message>
      </div>
  </div>
  
    <div class="row">
      <div class="col-sm-12">
        <h4 class="text-gray-700">
          {{'CardFamilyBenefits.FamilyBenefitsTable.Titulo' | translate}}
        </h4>
      </div>

      <div class="col-sm-8">
        <div class="form-group">
          <label for="Name"><span class="mandatory">*</span>{{'CardFamilyBenefits.FamilyBenefitsTable.Name' | translate}}</label>
          <input class="form-control" type="text" placeholder="{{'Placeholders.CardFamilyBenefits.FamilyBenefitsTable.Name' | translate}}" [(ngModel)]="item.name" name="name" #name="ngModel" maxlength="60" required>
          <validation-message [control]="name"></validation-message>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label for="DateOfBirth">
            <span class="mandatory">*</span>{{'CardFamilyBenefits.FamilyBenefitsTable.DateOfBirth' | translate}}
            <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardFamilyBenefits.DateOfBirth' | translate}}"></span>
          </label>
          <div class="input-group">
              <input #dpDateOfBirth="bsDatepicker" bsDatepicker
                    type="text" placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                   [maxDate]="maxDate" [minDate]="minDate"
                   autocomplete="off"
                   class="form-control DatepickerCustomClasse"
                   [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                   [(ngModel)]="item.dateOfBirth" name="dateOfBirth" #dateOfBirth="ngModel" required
                   maxlength="10"
                   (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpDateOfBirth)" />
            <div class="input-group-append disable-on-fieldset" (click)="!dpDateOfBirth.isDisabled && dpDateOfBirth.toggle()">
                <span class="input-group-text" id="basic-addon2">
                    <i class="icon-calendar"></i>
                </span>
            </div>
            <validation-message [control]="dateOfBirth"></validation-message>
          </div>
        </div>
      </div>
    </div>

    <div class="row">

      <div class="col-sm-4">
        <div class="form-group">
          <label for="Nationality"><span class="mandatory">*</span>{{'CardFamilyBenefits.FamilyBenefitsTable.Nationality' | translate}}</label>
          <select class="custom-select" [(ngModel)]="item.nationalityCode" name="nationalityCode" #nationalityCode="ngModel" required
                  [dropdownTitle]="{value : item.nationalityCode, dimensions : nationalities }" nullableSelect>
            <default-dropdown-values></default-dropdown-values>
            <option *ngFor="let domain of nationalities" [value]="domain.code">
              {{domain.description}}
            </option>
          </select>
          <validation-message [control]="nationalityCode"></validation-message>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label for="Gender"><span class="mandatory">*</span>{{'CardFamilyBenefits.FamilyBenefitsTable.Gender' | translate}}</label>
          <select class="custom-select" [(ngModel)]="item.genderCode" name="genderCode" #genderCode="ngModel" required
                  [dropdownTitle]="{value : item.genderCode , dimensions : genders }" nullableSelect>
            <default-dropdown-values></default-dropdown-values>
            <option *ngFor="let domain of genders" [value]="domain.code">
              {{domain.description}}
            </option>
          </select>
          <validation-message [control]="genderCode"></validation-message>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label for="MaritalStatus"><span class="mandatory">*</span>{{'CardFamilyBenefits.FamilyBenefitsTable.MaritalStatus' | translate}}</label>
          <select class="custom-select" [(ngModel)]="item.maritalStatusCode" name="maritalStatusCode" #maritalStatusCode="ngModel" required
                  [dropdownTitle]="{value : item.maritalStatusCode, dimensions : maritalStatuses }" nullableSelect>
            <default-dropdown-values></default-dropdown-values>
            <option *ngFor="let domain of maritalStatuses" [value]="domain.code">
              {{domain.description}}
            </option>
          </select>
          <validation-message [control]="maritalStatusCode"></validation-message>
        </div>
      </div>

    </div>

    <div class="row">

      <div class="col-sm-4">
        <div class="form-group">
          <label for="DocumentType"><span class="mandatory">*</span>{{'CardFamilyBenefits.FamilyBenefitsTable.DocumentType' | translate}}</label>
          <select class="custom-select" [(ngModel)]="item.documentTypeCode" name="documentTypeCode" #documentTypeCode="ngModel" required
                  [dropdownTitle]="{value : item.documentTypeCode, dimensions : documentTypes }"
                  [clearRelated]="{model : this.item, propsToReset : ['identificationNumber','verificationNumber']} " nullableSelect>
            <default-dropdown-values></default-dropdown-values>
            <option *ngFor="let domain of documentTypes" [value]="domain.code">
              {{domain.description}}
            </option>
          </select>
          <validation-message [control]="documentTypeCode"></validation-message>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label for="IdentificationNumber"><span class="mandatory">*</span>{{'CardFamilyBenefits.FamilyBenefitsTable.IdentificationNumber' | translate}}</label>
          <div class="form-row">
            <div class="col-sm-9">
              <input class="form-control" type="text" placeholder="{{'Placeholders.CardFamilyBenefits.FamilyBenefitsTable.IdentificationNumber' | translate}}" [(ngModel)]="item.identificationNumber" name="identificationNumber" #identificationNumber="ngModel" maxlength="8" required>
            <validation-message [control]="identificationNumber"></validation-message>
            </div>
            <div class="col-sm-3" [ngClass]="item.documentTypeCode != 'B' && item.documentTypeCode != 'CC' ? 'disabled' : ''">
              <input class="form-control text-center" type="text" numeric="1" [(ngModel)]="item.verificationNumber" name="verificationNumber" #verificationNumber="ngModel" minValue="1" maxValue="9" [required]="item.documentTypeCode == 'B'  || item.documentTypeCode == 'CC'" [disabled]="item.documentTypeCode != 'B' && item.documentTypeCode != 'CC'">
              <validation-message class="invisible"></validation-message>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label for="FiscalNumber"><span class="mandatory">*</span>{{'CardFamilyBenefits.FamilyBenefitsTable.FiscalNumber' | translate}}</label>
          <input class="form-control" type="text" numeric="9" placeholder="{{'Placeholders.CardFamilyBenefits.FamilyBenefitsTable.FiscalNumber' | translate}}" [(ngModel)]="item.fiscalNumber" name="fiscalNumber" #fiscalNumber="ngModel"  maxlength="9" nifValidation required>
          <validation-message [control]="fiscalNumber"></validation-message>
        </div>
      </div>

    </div>
    <div class="row">

      <div class="col-sm-4">
        <div class="form-group">
          <label for="Disabled"><span class="mandatory">*</span>{{'CardFamilyBenefits.FamilyBenefitsTable.Disabled' | translate}}</label>
          <div class="btn-group btn-group-toggle" >
            <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==item.disabled" [radioLabel]="disabled">
              <input type="radio" [(ngModel)]="item.disabled" name="disabled" #disabled="ngModel" [value]="domain.value" required>
              {{domain.description}}
            </label>
            <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
          </div>
        </div>
      </div>
    </div>

    <span *ngIf="!tableItemEditForm.valid" class="text-danger validation_error_all">{{'Generic.ValidationErrorCardAll' | translate}}</span>

</form>

<div class="d-flex justify-content-between mt-4 mb-2">
  <button type="button" class="btn btn-outline-primary disable-on-fieldset" (click)="onRemove(isEdit)"><span [ngClass]="isEdit ? 'icon-trash' : 'icon-close'"></span><span>{{isEdit ?  'Remover' : 'Cancelar'}}</span></button>
  <button type="button" class="btn btn-primary disable-on-fieldset" aria-label="Aplicar" (click)="onEdit(isEdit)"><span class="icon-check"></span><span>Aplicar</span></button>
</div>

